import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import FileUpload from './FileUpload'
import TextEditor from '../../../../components/TextEditor'
import { axiosInstance } from '../../../../const/axiosInstance'
import styles from './edit.module.css'

export default function EditDeclaration({add}) {
    const [declaration, setDeclaration] = useState({})
    const [image, setImage] = useState('')
    const [name, setName] = useState('')
    const [information, setInformation] = useState('')
    const [language, setLenguage] = useState("")
    const [fromLang, setFromLang] = useState(false)

    const {id} = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            if(!add){
                const res = await axiosInstance.get(`/use/declaration/${id}`)
                if(res.data.status){
                    setDeclaration(res.data.data)
                    setImage(res.data.data.image)
                }
            }
            setLenguage("arm")
            })()
    },[])

    useEffect(() => {
        if( name !== "" && information !== '' && information !== '<p></p>\n'){
            setDeclaration(prev => ({...prev, [`${language}name`]: name, [`${language}information`]: information }))
        }
    }, [information, name])

    useEffect(() => {
        if(language){
            if(!add){
                setFromLang(true)
                setName(declaration[`${language}name`])
                setInformation(declaration[`${language}information`])
            }else{
                setName("")
                setInformation("")
            }
        }
    }, [language])

    const changeLanguage = async () => {
        if(name && information){
            if(language == "arm"){
               setLenguage("ru")
            }
            if(language == "ru"){
                setLenguage("eng")
            }
        }else{
            return 
        }
    }

    useEffect(() => {
        setDeclaration(prev => {return {...prev, image}})
    }, [image])

    const addDeclartion = async () => {
        await axiosInstance.post(`/admin/declaration/add`, declaration)
        navigate("/dashboard/declaration")
    }

    const editDeclaration = async () => {
        await axiosInstance.post(`/admin/declaration/edit`, declaration)
        navigate("/dashboard/declaration")
    }
  
  return (
    <div className={styles['edit-part']}>
        <h2>{language == "arm" ? "Հայերեն" : language == "ru" ? "Ռուսերեն" : "Անգլերեն"}</h2>
        <div className={styles['upload']}>
            <p>{add ? 'Ավելացնել' : 'Փոխել'} հայտարարության նկարը։ </p>
            <FileUpload setImage={setImage}/>  
            <input disabled={true} placeholder='ֆայլ' value={image}/>
        </div>
        <div className={styles['info']}>
            <p>Հայտարարության անվանում։ </p>
            <input type='text' placeholder='Հայտարարության անվանում' value={name} onChange={(e) => setName(e.target.value)}/>
        </div>
        <div>
            <p>Հայտարարության մասին: </p>
            <TextEditor setInformation={setInformation} information={information} fromLang={fromLang} setFromLang={setFromLang}/>
        </div>
        <div className={styles['btn-div']}>
            {language != "eng" ? 
                    <button className={`${styles['btn']} ${styles['confirm']}`} onClick={changeLanguage}>Հաջորդ</button> 
                    : !name || !information || !image || information == '<p></p>\n' ? <button disabled className={`${styles['btn']} ${styles['confirm']}`}>Հաստատել</button>
                    :
                    <button className={`${styles['btn']} ${styles['confirm']}`} onClick={add ? addDeclartion : editDeclaration}>Հաստատել</button>}
            <Link to='/dashboard/declaration'><button className={`${styles['btn']} ${styles['cancel']}`}>Չեղարկել</button></Link>
        </div>
    </div>
  )
}